import moment from "moment";

export const USAGE_PRESETS = [
  { value: "today", label: "Today" },
  { value: "last7", label: "Last 7 days" },
  { value: "lastMonth", label: "Last month" },
  { value: "custom", label: "Custom" },
];

const DAY = "YYYY-MM-DD";
const MAX_DAYS = 366;

// The API counts whole UTC days, so the ranges are worked out in UTC too.
export function presetRange(preset) {
  const now = moment.utc();
  switch (preset) {
    case "last7":
      return {
        startDate: now.clone().subtract(6, "days").format(DAY),
        endDate: now.format(DAY),
      };
    case "lastMonth": {
      const month = now.clone().subtract(1, "months");
      return {
        startDate: month.clone().startOf("month").format(DAY),
        endDate: month.clone().endOf("month").format(DAY),
      };
    }
    case "today":
    default:
      return { startDate: now.format(DAY), endDate: now.format(DAY) };
  }
}

export const todayUtc = () => moment.utc().format(DAY);

// "" when the range can be sent to the API, otherwise what is wrong with it
export function rangeProblem({ startDate, endDate }) {
  if (!startDate || !endDate) return "Pick both a start and an end date.";
  if (startDate > endDate) return '"From" must be on or before "To".';
  // the API refuses longer periods
  if (moment.utc(endDate, DAY).diff(moment.utc(startDate, DAY), "days") >= MAX_DAYS) {
    return `Pick a period of at most ${MAX_DAYS} days.`;
  }
  return "";
}

// "5 Nov 2026", "1 Oct – 31 Oct 2026", "15 Dec 2025 – 3 Jan 2026"
export function formatPeriod({ startDate, endDate }) {
  const start = moment.utc(startDate, DAY, true);
  const end = moment.utc(endDate, DAY, true);
  if (!start.isValid() || !end.isValid()) return "—";
  if (start.isSame(end, "day")) return end.format("D MMM YYYY");
  const from = start.year() === end.year() ? start.format("D MMM") : start.format("D MMM YYYY");
  return `${from} – ${end.format("D MMM YYYY")}`;
}
